import React, { useState, useEffect, useCallback } from "react";
import styles from "./PopUpSlider.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { Link, useLocation } from "react-router-dom";
import CustomModal from "../Modal/CustomModal";
import useReactGASend from "../../hooks/useReactGASend";
import { useDispatch, useSelector } from "react-redux";
import {
  setModalDate,
  setPopupVisible,
} from "#src/modules/reducers/promotion/popUpSlider.js";

const PopUpSlider = ({ items }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { makeEventTrackFn } = useReactGASend();

  const isVisible = useSelector((state) => state.popUpSlider.popupVisible);
  const modalDate = useSelector((state) => state.popUpSlider.modalDate);

  const updateVisibility = useCallback(() => {
    const today = new Date().toLocaleDateString();
    if (modalDate !== today) {
      dispatch(setPopupVisible({ popupVisible: true }));
    }
  }, []);

  useEffect(() => {
    updateVisibility();

    const handleVisibilityChange = () => {
      if (
        document.visibilityState === "visible" &&
        location.pathname === "/landing"
      ) {
        updateVisibility();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [location.pathname, updateVisibility]);

  const handleClose = useCallback((hideForToday) => {
    dispatch(setPopupVisible({ popupVisible: false }));

    if (hideForToday) {
      const today = new Date().toLocaleDateString();
      dispatch(setModalDate({ modalDate: today }));
      makeEventTrackFn({
        category: "event",
        action: "오늘 하루 보지 않기 클릭",
      });
    }
  }, []);

  const trackLinkClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: `팝업 이미지 ${title}`,
    });
  };

  const [paddingTop, setPaddingTop] = useState("141.4%"); // A2 비율
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1600) {
        setPaddingTop("35%"); // PC 버전
      } else if (window.innerWidth >= 640) {
        setPaddingTop("90%");
      } else if (window.innerWidth >= 380) {
        setPaddingTop("141.4%");
      } else {
        setPaddingTop("100%");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // 초기 로드 시 호출

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <CustomModal
      isOpen={isVisible}
      onRequestClose={() => dispatch(setPopupVisible({ popupVisible: true }))}
      contentLabel="오늘 하루 보지 않기 랜딩 팝업"
      modalBottom
    >
      <Swiper
        pagination={{ clickable: true }}
        modules={[Pagination, Autoplay]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        className={styles.slider}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index} className={styles.item}>
            <Link to={item.url} onClick={() => trackLinkClick(item.title)}>
              <div style={{ paddingTop }} className="relative overflow-hidden ">
                <img
                  src={item.image}
                  alt={item.label}
                  className="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                />
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="w-full flex items-center justify-end gap-2 mt-4">
        <PopupButton
          onClick={() => handleClose(true)}
          label="오늘 하루 보지 않기"
        />
        <PopupButton onClick={() => handleClose(false)} label="닫기" />
      </div>
    </CustomModal>
  );
};

const PopupButton = ({ onClick, label }) => (
  <button
    className="w-1/2 py-3 text-sm font-semibold bg-white border rounded-2xl border-neutral-300"
    onClick={onClick}
  >
    {label}
  </button>
);

export default PopUpSlider;
